import type { FC, ReactNode } from 'react';
import { useCallback, useMemo, useState } from 'react';
import type { AppCode } from '../constants';
import type { GlobalSettings, GlobalSettingsContextValue, ServiceNetwork } from './globalSettings';
import { GlobalSettingsContext, readGlobalSettings, writeGlobalSettings } from './globalSettings';

export const GlobalSettingsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<GlobalSettings>(readGlobalSettings);

  const setSelectedApp = useCallback((app: AppCode) => {
    setSettings((prev) => {
      const next: GlobalSettings = { ...prev, app };
      writeGlobalSettings(next);

      return next;
    });
  }, []);

  const setSelectedNetwork = useCallback((network: ServiceNetwork) => {
    setSettings((prev) => {
      const next: GlobalSettings = { ...prev, network };
      writeGlobalSettings(next);

      return next;
    });
  }, []);

  const value = useMemo<GlobalSettingsContextValue>(
    () => ({
      selectedApp: settings.app,
      setSelectedApp,
      selectedNetwork: settings.network,
      setSelectedNetwork,
    }),
    [settings.app, settings.network, setSelectedApp, setSelectedNetwork],
  );

  return (
    <GlobalSettingsContext.Provider value={value}>
      {children}
    </GlobalSettingsContext.Provider>
  );
};

export default GlobalSettingsProvider;
